<mat-card-title class="flex row" *ngIf="searchName !== undefined">{{ searchName }} Search</mat-card-title>
<div class="cmn-flex row gutters">
    <mat-form-field *ngIf="filterConfig.enable === true">
        <mat-select [formControl]="filterControl" [(ngModel)]="filterConfig.defaultOption" (selectionChange)="filterChanged($event)">
            <mat-option *ngFor="let filter of filterConfig.filterOptions" [value]="filter">
                {{filter}}
            </mat-option>
        </mat-select>
        <mat-hint>{{filterConfig.filterHint}}</mat-hint>
    </mat-form-field>
    <mat-form-field class="flex">
        <mat-label>{{ label }}</mat-label>
        <input #inputAutoComplete [(ngModel)]="inputValue" (ngModelChange)="change()" [disabled]="disabled"
               (click)="change()" #searchInput [matAutocomplete]="auto"
               [appAutofocus]="doAutofocus" class="left" matInput id="autocompleteInput" [cmnDebounce]=debounceTime>
        <mat-autocomplete #auto="matAutocomplete" #autocomplete (optionSelected)="selected($event)"
                          autoActiveFirstOption id="matAutocomplete">
            <mat-option *ngFor="let option of options " [value]="option" id="optionList">
                {{option}}
            </mat-option>
        </mat-autocomplete>
        <mat-hint>{{ hint }}</mat-hint>
    </mat-form-field>
    <button *ngIf="buttonConfig.enable === true" (click)="addClick($event)" [disabled]="disabled"
            aria-label="Add Icon" color="primary" [id]="buttonConfig.id" mat-icon-button>
        <mat-icon>{{buttonConfig.icon}}</mat-icon>
    </button>
</div>
